import * as React from 'react';

import { MediaResourceTypes } from '@showbie-socrative/socrative-utils';

import ImagePreviewer from '~shared/components/ImageField/ImagePreviewer';
import { MediaPlayer } from '~shared/components/MediaPlayer';

import { useResultQuestionState } from '../ActivityResult/ActivityResultQuestionProvider';

export function ResultsQuestionMedia(): React.ReactElement {
  const questionContext = useResultQuestionState();
  const {
    question: { questionId, questionImage, questionVideo, questionAudio } = {},
  } = questionContext;
  const questionMedia = questionImage || questionVideo || questionAudio;

  switch (questionMedia?.type) {
    case MediaResourceTypes.Image:
      return (
        <ImagePreviewer
          imageURL={questionImage.urlS}
          imageStyle="max-h-70 rounded-2"
          showOutline
          containerStyle="max-w-70 max-h-70 mt-6 lg:mt-0 ml-15 lg:ml-0 lg:row-span-2 lg:col-start-2 lg:text-right rounded-2"
          allowZoom
          zoomImageURL={questionImage.url}
        />
      );
    case MediaResourceTypes.Video:
      return (
        <MediaPlayer
          key={`results-question-video-${questionId}`}
          url={questionVideo.url}
          start={questionVideo?.start}
          end={questionVideo?.end}
          type={MediaResourceTypes.Video}
          controls
          containerStyle="w-124 h-70 mt-6 ml-0 sm:ml-15 sm:w-124 lg:mt-0 lg:ml-0 lg:row-span-2 lg:col-start-2 lg:text-right"
        />
      );
    default:
      return null;
  }
}
